import usePostData from '../../../../../hooks/postHook';

export const useRemovePhotos = ({ id }) => {
  const [{ body, isLoading, isError, error }, removePhotos] = usePostData(
    `office_product/${id}/photos/remove`
  );

  return { body, isLoading, isError, error, removePhotos };
};
